import type { MessageKey } from '../../i18n';
import { createColumnsHook, type ColumnsState } from '../../lib/table-columns';

/**
 * Optional columns of the run list. Key and title are not here: they identify
 * the row and are always shown.
 */
export const RUN_COLUMNS = [
  'checklist',
  'status',
  'labels',
  'result',
  'environment',
  'assignee',
  'created',
] as const;

export type RunColumn = (typeof RUN_COLUMNS)[number];

export const RUN_COLUMN_LABELS: Record<RunColumn, MessageKey> = {
  checklist: 'runs.columnChecklist',
  status: 'common.status',
  labels: 'labels.title',
  result: 'runs.columnResults',
  environment: 'runs.columnEnvironment',
  assignee: 'runs.columnAssignee',
  created: 'common.created',
};

/** Everything the list showed before the picker existed. */
const DEFAULT_COLUMNS: RunColumn[] = [...RUN_COLUMNS];

export const RUN_COLUMNS_STORAGE_KEY = 'tms.runColumns';

export type RunColumnsState = ColumnsState<RunColumn>;

export const useRunColumns = createColumnsHook({
  columns: RUN_COLUMNS,
  defaults: DEFAULT_COLUMNS,
  storageKey: RUN_COLUMNS_STORAGE_KEY,
});
